export interface SeoJsonLdProps {
  data: Record<string, unknown> | Record<string, unknown>[];
}

export default function SeoJsonLd({ data }: SeoJsonLdProps) {
  const schemas = Array.isArray(data) ? data : [data];

  return (
    <>
      {schemas.map((schema, idx) => (
        <script
          key={idx}
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
        />
      ))}
    </>
  );
}